import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Quality.css";
import { qualityApi } from "./qualityApi";
import { MockBanner, ReleasePill, fmtDate, pct } from "./qualityUi";

/**
 * Production Releases — the internal record of what went live.
 *
 * Not the same thing as What's New: that is the customer announcement and only
 * holds the tickets chosen for it. This holds every ticket that shipped, with
 * its testers and approver as they were at release time, and the regression
 * run the release had to pass.
 */
export default function ProductionReleases() {
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState("");

    useEffect(() => {
        qualityApi.getReleases()
            .then((res) => setRows(res.data || []))
            .catch((e) => setErr(e.message || "Could not load releases."))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="qa-page">
            <MockBanner />
            <div className="qa-head">
                <h1>Production Releases</h1>
                <span className="qa-hint">Every ticket that went live, with its regression run</span>
            </div>

            <div className="qa-toolbar">
                <span className="qa-toolbar__count">{loading ? "Loading…" : `${rows.length} release${rows.length === 1 ? "" : "s"}`}</span>
            </div>
            <div className="qa-card">
                {err ? <div className="qa-empty">{err}</div> : (
                    <table className="qa-tbl">
                        <thead>
                            <tr>
                                <th>Version</th><th>Release date</th><th>Status</th><th>Tickets</th>
                                <th>Regression</th><th>Escaped bugs</th><th>Leakage</th><th>Deployments</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!loading && rows.length === 0 && (
                                <tr><td colSpan={8} className="qa-empty">No releases recorded yet.</td></tr>
                            )}
                            {rows.map((r) => (
                                <tr key={r.id} className="qa-click" onClick={() => navigate(`/quality/releases/${r.id}`)}>
                                    <td className="qa-code qa-mono">{r.version}</td>
                                    <td className="qa-nw qa-muted">{fmtDate(r.release_date)}</td>
                                    <td><ReleasePill value={r.status} /></td>
                                    <td className="qa-num">{r.ticket_count}</td>
                                    <td>
                                        <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 130 }}>
                                            <div
                                                className="qa-kpi__bar"
                                                style={{ flex: 1, margin: 0, "--kc": r.stats.coverage === 100 ? "var(--qa-green)" : "var(--qa-amber)" }}
                                            >
                                                <i style={{ width: `${r.stats.coverage}%` }} />
                                            </div>
                                            <span className="qa-num qa-hint">{r.stats.coverage}%</span>
                                        </div>
                                    </td>
                                    <td className="qa-num" style={{ color: r.stats.escaped ? "var(--qa-red)" : undefined }}>{r.stats.escaped}</td>
                                    <td className="qa-num">{pct(r.stats.leakage)}</td>
                                    <td>
                                        <div className="qa-meta">
                                            {r.servers.map((s) => <span key={s.code} className="qa-chip">{s.label}: {s.version}</span>)}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}
